/**
 * Reubica logos de content_for (.body-topics) al marquee:
 * - practice → carrusel en columna derecha (bajo temas + «Vive lo mejor del deporte»)
 * - learning → carrusel inferior a ancho completo
 */
function relocateAcademyLogos(section) {
  const sources = section.querySelectorAll(
    '.offsider-academy-learning__body-topics .offsider-academy-partner-logo'
  );

  if (sources.length === 0) return false;

  const target = section.querySelector(
    '[data-logo-target="practice-inline"] .marquee__repeated-items, [data-logo-target="bottom-marquee"] .marquee__repeated-items'
  );

  if (!target) return false;

  sources.forEach((logo) => {
    target.appendChild(logo);
  });

  return true;
}

function refreshAcademyLogoMarquee(section) {
  const marquee = section.querySelector(
    '[data-logo-target="practice-inline"] marquee-component, [data-logo-target="bottom-marquee"] marquee-component'
  );

  if (!marquee) return;

  window.dispatchEvent(new Event('resize'));
}

function initAcademyLogoRelocation() {
  document.querySelectorAll('.offsider-academy-learning').forEach((section) => {
    const moved = relocateAcademyLogos(section);
    if (moved) {
      requestAnimationFrame(() => {
        refreshAcademyLogoMarquee(section);
      });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAcademyLogoRelocation);
} else {
  initAcademyLogoRelocation();
}

/** Mover logos y refrescar marquee cuando conecta el host */
class OffsiderAcademyLearningLogos extends HTMLElement {
  connectedCallback() {
    const section = this.closest('.offsider-academy-learning');
    if (!section) return;

    const moved = relocateAcademyLogos(section);

    if (moved) {
      requestAnimationFrame(() => {
        refreshAcademyLogoMarquee(section);
      });
    }
  }
}

if (!customElements.get('offsider-academy-learning-logos')) {
  customElements.define('offsider-academy-learning-logos', OffsiderAcademyLearningLogos);
}
